const CheckoutTotalService = {
  calcItemTotal: (shipment) => {
    if (!shipment) return 0
    var total = 0
    shipment?.items.forEach((item) => {
      total += item.product.selling_price * item.quantity
    })
    return total
  },

  calcItemTotalDiscount: (discountItems) => {
    var total = 0
    discountItems.forEach((item) => {
      total += item.discount_amount
    })
    return total
  },

  calcShipmentTotal: (selectedShipmentMethod) => selectedShipmentMethod ? selectedShipmentMethod.cost : 0,

  calcPaymentRateTotal: (paymentRate, amount) => {
    if (!paymentRate) return 0
    if (paymentRate.calculation_type === 'absolute') return parseInt(paymentRate.absolute_value)
    if (paymentRate.calculation_type === 'percentage') return amount * parseFloat(paymentRate.percentage_value)
  },

  calcShipmentInsuranceTotal: (selected_shipment_method) => {
    var total = 0
    if ( selected_shipment_method?.is_insurance) {
      total += selected_shipment_method.insurance_cost
    }
    return total
  },

  // function to transform a set of checkout attributes into Customer::Order (total attributes only)
  transformToOrder: ({
    shipment,
    selectedPayment,
    voucherDiscount={ discount_items: [], discount_shipment: 0 },
    selectedShipment
  }) => {
    // Get Discount First
    const { discount_items, discount_shipment } = voucherDiscount

    const itemPriceTotal         = CheckoutTotalService.calcItemTotal(shipment)
    const itemDiscountTotal      = CheckoutTotalService.calcItemTotalDiscount(discount_items)
    const shipmentCostTotal      = CheckoutTotalService.calcShipmentTotal(selectedShipment)
    const shipmentInsuranceTotal = CheckoutTotalService.calcShipmentInsuranceTotal(selectedShipment)

    // Total for Payment Method Rate
    const subTotal = itemPriceTotal
      + shipmentCostTotal
      + shipmentInsuranceTotal

    // Final Total
    const discountTotal          = itemDiscountTotal + discount_shipment
    const paymentMethodRateTotal = CheckoutTotalService.calcPaymentRateTotal(selectedPayment?.rate, subTotal + discountTotal)

    const total = itemPriceTotal
      + shipmentCostTotal
      + paymentMethodRateTotal
      + discountTotal
      + shipmentInsuranceTotal

    // initialize order object
    const order = {
      item_price_total          : itemPriceTotal,
      item_discount_total       : itemDiscountTotal,
      shipment_cost_total       : shipmentCostTotal,
      shipment_insurance_total  : shipmentInsuranceTotal,
      shipment_discount_total   : discount_shipment,
      payment_method_rate_total : paymentMethodRateTotal,
      total                     : total
    }

    return order
  },

  // updating order total based on payment method rate choosed
  updateTotalFromPaymentMethod: (order, paymentMethod) => {
    const discountTotal    = order.item_discount_total + order.shipment_discount_total
    const subTotal         = order.item_price_total + order.shipment_cost_total + order.shipment_insurance_total
    const paymentRateTotal = CheckoutTotalService.calcPaymentRateTotal(paymentMethod?.rate, subTotal + discountTotal)
    const total            = subTotal + paymentRateTotal + discountTotal

    const updatedOrder = {
      ...order,
      payment_method_rate_total : paymentRateTotal,
      total                     : total
    }

    return updatedOrder
  }
}

export default CheckoutTotalService